<template>
  <div id="clients-cards"
       class="client-card">
    <div v-for="i in Math.ceil(filteredClients.length / getSliceNumber())"
         class="row small-up-2 medium-up-4">
      <div v-for="(client, index) in filteredClients.slice((i - 1) * getSliceNumber(), i * getSliceNumber())"
           :class="getClientColumnClass(client.domain, index + ((i - 1)  * getSliceNumber()))"
           class="client column">
        <div :class="getImgClass(client.domain)"
             class="ui card">
          <div class="image">
            <!-- client logo -->
            <img :src="client.logo"
                 @click="selectClient(client.domain)">
            <!-- ./client logo -->
            <!-- favorite icon -->
            <a v-if="isLoggedIn"
               class="favorite-wrapper ui right corner label">
              <i v-if="!isThisMyFavoriteClient(client.domain)"
                 class="star icon"
                 @click="favoriteClientClick(client.domain)"></i>
              <i v-else
                 class="star icon selected"
                 @click="favoriteClientClick(client.domain)"></i>
            </a>
            <!-- ./favorite icon -->
            <!-- featured icon -->
            <div v-if="isFeaturedClient(client)"
                 class="ui blue ribbon label">Kiemelt
            </div>
            <!-- ./featured icon -->
          </div>
          <div class="content">
            <!-- client name -->
            <a class="header"
               @click="selectClient(client.domain)">{{ client.name }}</a>
            <!-- ./client name -->
            <div class="meta">
              <!-- client address -->
              <span class="date">{{ client.city }}, {{ client.address }}</span>
              <!-- ./client address -->
            </div>
            <div class="description">
              <!-- client subjects -->
              <span v-for="globalSubjectType in client.availableGlobalSubjectTypes">
                <img :src="getGlobalSubjectTypeByKey(globalSubjectType).iconUrl"
                     :title="getGlobalSubjectTypeByKey(globalSubjectType).name"
                     class="subject-type-icon"/>
            </span>
              <!-- ./client subjects -->
            </div>
          </div>
          <div class="extra content">
            <!-- distance -->
            <span v-if="getGoogleDirectionUrl(client)">
              <a :href="getGoogleDirectionUrl(client)"
                 data-push="false"
                 target="_blank">
                <i class="location arrow icon"></i>{{ getDistanceText(client.lat, client.lng) }} km távolság
              </a>
            </span>
            <span v-else>{{ getDistanceText(client.lat, client.lng) }} km távolság</span>
            <!-- ./distance -->
          </div>
        </div>
      </div>
      <!-- TODO: fix this error -->
      <!-- eslint-disable-next-line -->
      <div v-if="!isMobileDevice && filteredClients.slice((i - 1) * 4, i * 4).length < 4">
        <div v-for="num in getHelperCardNumber"
             :class="getClientColumnClass(false, (num + 5))"
             class="client column">
        </div>
      </div>

      <div v-for="client in filteredClients.slice((i - 1) * getSliceNumber(), i * getSliceNumber())"
           :class="{active: client.domain === currentClientDomain}"
           class="schedule-table-container-wrapper">
        <schedule-table-container :container-client-domain="client.domain"
                                  :is-logged-in="isLoggedIn"
                                  :is-mobile-device="isMobileDevice"
                                  @create-new-reservation="createNewReservation"
                                  @resign-reservation="resignReservation"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ScheduleTableContainer from '../schedule/ScheduleTableContainer'

export default {
  props: ['filteredClients', 'isMobileDevice', 'isLoggedIn', 'isFeaturedClient', 'getGoogleDirectionUrl',
    'getGlobalSubjectTypeByKey', 'getDistanceText', 'favoriteClientClick', 'isThisMyFavoriteClient',
    'currentPaginationPage'],
  methods: {
    selectClient (domain) {
      this.$store.dispatch('selectClient', domain);
    },
    getClientColumnClass (domain, index) {
      let currentClientDomain = this.currentClientDomain
      let result = {
        'selected': domain === currentClientDomain && !this.isMobileDevice,
      }
      let currentClientDomainIndex = null
      let filteredClients = this.filteredClients

      for (let i in filteredClients) {
        let client = filteredClients[i]
        if (client.domain === currentClientDomain) {
          currentClientDomainIndex = i
        }
      }

      if (currentClientDomainIndex && !this.isMobileDevice) {
        if (filteredClients.length < 4) {
          result['passive-border'] = domain !== currentClientDomain
        } else {
          if (currentClientDomainIndex < 4) {
            result['passive-border'] = (domain !== currentClientDomain && index < 4)
          } else {
            result['passive-border'] = (domain !== currentClientDomain && index >= 4)
          }
        }
      }

      return result
    },
    getSliceNumber () {
      if (this.isMobileDevice) {
        return 2
      }
      return 4
    },
    createNewReservation (payload) {
      this.$emit('create-new-reservation', payload)
    },
    resignReservation (payload) {
      this.$emit('resign-reservation', payload)
    },
  },
  computed: {
    currentClientDomain () {
      return this.$store.state.currentClientDomain
    },
    getImgClass () {
      return function (domain) {
        let currentDomain = this.$store.state.currentClientDomain
        let myFavoriteClient = null
        if (this.$store.state.user) {
          myFavoriteClient = this.$store.state.user.favoriteClient
        }
        let results = {
          'is-passive': false,
          'favorite-card': false,
        }
        if (currentDomain) {
          if (currentDomain !== domain) {
            results['is-passive'] = true
          }
        }
        if (domain === myFavoriteClient) {
          results['favorite-card'] = true
          // results['orange'] = true
        }
        return results
      }
    },
    getHelperCardNumber: function () {
      /* eslint-disable */
      // let currentPagPage = this.currentPaginationPage
      let cardNumber = this.filteredClients.length
      let result = 0
      let cardPerPage = 8

      // don't need helper card
      if (cardNumber === cardPerPage) {
        return 0
      }

      result = (cardPerPage - cardNumber)

      // bad pag page
      if (result > 8) {
        return 0
      }

      if (result > 4) {
        result = result - 4
      }

      // can't negative number of card(s)
      if (result < 0) {
        return 0
      }

      return result
    },
  },
  watch: {
    filteredClients: function (newFilteredClients) {
      this.$nextTick(function () {
        // Code that will run only after the
        // entire view has been re-rendered
        // addScheduleTablePlaces()
      })
    },
  },
  components: {
    ScheduleTableContainer,
  },
}

function addScheduleTablePlaces () {
  /* eslint-disable */
  $('#scheduleTableContainer').appendTo('#schedule-table-default-place')
  $('.schedule-table-place').remove();

  let clientsCards = $('#clients-cards').children()

  // alert('addSchedule run: ' + clientsCards.length)

  if (clientsCards.length > 0) {
    clientsCards.last().after('<div id=\'schedule-table-place-id-last\' class=\'schedule-table-place\'></div>')
    if (clientsCards.length > 4) {
      $('<div id=\'schedule-table-place-id-1\' class=\'schedule-table-place\'></div>').insertAfter('#clients-cards > div:nth-child(4)')
    }
  }
}
</script>

<style scoped>
.ui.card {
  transition: all 0.5s ease-in;
}

.is-passive {
  opacity: 0.4;

}

.denied-location {
  font-size: 110%;
  margin: auto;
}

.image {
  cursor: pointer;
}

/* favorit */
.favorite-wrapper > i {
  transition: color .1s ease;
  color: rgba(0, 0, 0, .4);
  cursor: pointer !important;
}

.favorite-wrapper > i:hover {
  color: #ffb70a;
  opacity: 1;
}

.favorite-wrapper > i.selected {
  color: #ffb70a;
}

.favorite-card {
  box-shadow: 0 0 0 1px #FF9000, 0 2px 0 0 #FF9000, 0 1px 3px 0 #FF9000;
}

/* --- ui card overwrite --- */

.ui.card, .ui.cards > .card {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  border: 2px solid #f0f1f3;
  border-radius: 0;
}

.ui.card > .content, .ui.cards > .card > .content {
  border: none;
}

.ui.card > .extra, .ui.cards > .card > .extra {
  border-top: 2px solid #f0f1f3 !important;
}

.ui.card > .image, .ui.cards > .card > .image {
  background: #f0f1f3;
}

.column.selected {
  border-style: solid;
  border-color: #a0a9b6;
  border-width: 1px 1px 0 1px;
}

.column.passive-border {
  border-bottom: 1px solid #a0a9b6;
}

.client.column {
  padding-top: 1rem;
}

.subject-type-icon {
  max-width: 2rem;
  margin-right: 0.5rem;
}

.schedule-table-container-wrapper {
  width: 100%;
}

.schedule-table-container-wrapper.active {
  padding: .5rem;
  border-left: 1px solid #a0a9b6;
  border-right: 1px solid #a0a9b6;
  border-bottom: 1px solid #a0a9b6;
}

@media only screen and (max-width: 39.9375em) {
  .schedule-table-container-wrapper.active {
    border: none;
  }
}

</style>
